(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7354,1692,7938],{

/***/ 13915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o3": function() { return /* reexport */ BlogSingleBanner; },
  "kS": function() { return /* reexport */ BlogSingleBody; },
  "RK": function() { return /* reexport */ BlogSingleHero; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./_modules/study/blog/blog_single/blog_single_hero.module.scss
var blog_single_hero_module = __webpack_require__(60740);
var blog_single_hero_module_default = /*#__PURE__*/__webpack_require__.n(blog_single_hero_module);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_modules/study/common/page_info/index.jsx
var page_info = __webpack_require__(47180);
// EXTERNAL MODULE: ./_unisearch/common/google_ad_top/index.jsx
var google_ad_top = __webpack_require__(56753);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/blog/blog_single/blog_single_hero.jsx

var _excluded = ["pageData"];









var BlogSingleHero = function BlogSingleHero(_ref) {
  var _pageData$parimaryCat, _pageData$parimaryCat2, _pageData$author, _pageData$author2;

  var pageData = _ref.pageData,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "".concat((blog_single_hero_module_default()).section_study_banner, " !pt-7"),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(google_ad_top/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (blog_single_hero_module_default()).hero_container,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (blog_single_hero_module_default()).sub_heading,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "bold",
            children: pageData === null || pageData === void 0 ? void 0 : pageData.categoryName
          }), "\xA0 ", (pageData === null || pageData === void 0 ? void 0 : pageData.content) && (0,helpers/* readingTime */.f6)(pageData === null || pageData === void 0 ? void 0 : pageData.content), " min read"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: "heading-one",
          children: pageData === null || pageData === void 0 ? void 0 : pageData.title
        }), pageData && (pageData === null || pageData === void 0 ? void 0 : pageData.summary) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (blog_single_hero_module_default()).summary,
          children: pageData !== null && pageData !== void 0 && pageData.summary ? (0,helpers/* htmlParse */.QA)(pageData === null || pageData === void 0 ? void 0 : pageData.summary) : ""
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (blog_single_hero_module_default()).breadcrumbs,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Home"
              })
            })
          }), " - ", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: "/blog",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Blog"
              })
            })
          }), pageData && (pageData === null || pageData === void 0 ? void 0 : pageData.parimaryCategory) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [" - ", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              legacyBehavior: true,
              href: "/blog/category/".concat(pageData === null || pageData === void 0 ? void 0 : (_pageData$parimaryCat = pageData.parimaryCategory) === null || _pageData$parimaryCat === void 0 ? void 0 : _pageData$parimaryCat.slug),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (blog_single_hero_module_default()).active,
                children: pageData === null || pageData === void 0 ? void 0 : (_pageData$parimaryCat2 = pageData.parimaryCategory) === null || _pageData$parimaryCat2 === void 0 ? void 0 : _pageData$parimaryCat2.title
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(page_info/* default */.Z, {
          pageType: "blog",
          data: pageData,
          id: pageData === null || pageData === void 0 ? void 0 : pageData.id,
          authorName: pageData === null || pageData === void 0 ? void 0 : (_pageData$author = pageData.author) === null || _pageData$author === void 0 ? void 0 : _pageData$author.authorName,
          authorImage: pageData === null || pageData === void 0 ? void 0 : (_pageData$author2 = pageData.author) === null || _pageData$author2 === void 0 ? void 0 : _pageData$author2.profileImageSrc
        })]
      })]
    })
  });
};
/* harmony default export */ var blog_single_hero = ((/* unused pure expression or super */ null && (BlogSingleHero)));
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./_modules/study/common/play_btn_with_ripple/index.jsx
var play_btn_with_ripple = __webpack_require__(42422);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./_modules/study/blog/blog_single/blog_single_banner.jsx








var ModalVideo = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1239).then(__webpack_require__.bind(__webpack_require__, 61239));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61239)];
    }
  }
});
var BlogSingleBanner = function BlogSingleBanner(_ref) {
  var _blog$posterImage, _blog$featureImage, _blog$videoUpload;

  var blog = _ref.blog;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "pb-6 lg:pb-10",
      style: {
        backgroundImage: "linear-gradient(180deg, #f1f5fd 50%, #ffffff 50%)"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "max-w-[970px] mx-auto relative",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            blurDataURL: (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
            placeholder: "blur",
            src: (blog === null || blog === void 0 ? void 0 : (_blog$posterImage = blog.posterImage) === null || _blog$posterImage === void 0 ? void 0 : _blog$posterImage.src) || (blog === null || blog === void 0 ? void 0 : (_blog$featureImage = blog.featureImage) === null || _blog$featureImage === void 0 ? void 0 : _blog$featureImage.src) || (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
            alt: "UniSearch - ".concat(blog === null || blog === void 0 ? void 0 : blog.title),
            width: 970,
            height: 545,
            className: "rounded-lg"
          }), blog && (blog === null || blog === void 0 ? void 0 : blog.videoType) && /*#__PURE__*/(0,jsx_runtime.jsx)(play_btn_with_ripple/* default */.Z, {
            onClick: function onClick() {
              return setOpen(true);
            }
          })]
        })
      })
    }), blog && (blog === null || blog === void 0 ? void 0 : blog.videoType) && (blog === null || blog === void 0 ? void 0 : blog.embeddedCode) && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo, {
      channel: "youtube",
      autoplay: true,
      videoId: blog === null || blog === void 0 ? void 0 : blog.embeddedCode,
      isOpen: isOpen,
      onClose: function onClose() {
        return setOpen(false);
      }
    }), blog && (blog === null || blog === void 0 ? void 0 : blog.videoType) && (blog === null || blog === void 0 ? void 0 : blog.videoUpload) && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo, {
      channel: "custom",
      autoplay: true,
      url: blog === null || blog === void 0 ? void 0 : (_blog$videoUpload = blog.videoUpload) === null || _blog$videoUpload === void 0 ? void 0 : _blog$videoUpload.src,
      isOpen: isOpen,
      onClose: function onClose() {
        return setOpen(false);
      }
    })]
  });
};
/* harmony default export */ var blog_single_banner = ((/* unused pure expression or super */ null && (BlogSingleBanner)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_modules/lead/components/index.js + 6 modules
var components = __webpack_require__(56205);
// EXTERNAL MODULE: ./_modules/study/common/social_sharing_links/index.jsx
var social_sharing_links = __webpack_require__(83380);
// EXTERNAL MODULE: ./_unisearch/common/advertisement/index.jsx
var advertisement = __webpack_require__(72275);
// EXTERNAL MODULE: ./_modules/study/blog/components/blog_grid_box/index.jsx
var blog_grid_box = __webpack_require__(27890);
// EXTERNAL MODULE: ./_modules/study/blog/blog_single/blog_single_body.module.scss
var blog_single_body_module = __webpack_require__(28257);
var blog_single_body_module_default = /*#__PURE__*/__webpack_require__.n(blog_single_body_module);
;// CONCATENATED MODULE: ./_modules/study/blog/blog_single/blog_single_body.jsx







var baseUrl = "https://myunisearch.com";









var UniComment = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2112), __webpack_require__.e(2109)]).then(__webpack_require__.bind(__webpack_require__, 32112));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(32112)];
    }
  }
});
var BlogSingleBody = function BlogSingleBody(_ref) {
  var _pageData$parimaryCat, _pageData$content, _pageData$tags, _pageData$tags2;

  var pageData = _ref.pageData;
  var catPrimary = pageData === null || pageData === void 0 ? void 0 : (_pageData$parimaryCat = pageData.parimaryCategory) === null || _pageData$parimaryCat === void 0 ? void 0 : _pageData$parimaryCat.title;

  var _useState = (0,react.useState)(),
      formData = _useState[0],
      setFormData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      posts = _useState3[0],
      setPosts = _useState3[1];

  var fetchData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var res;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api/* default.get */.Z.get("public/lead-contact-form/pages/popup");

            case 2:
              res = _context.sent;

              if (res && !res.error) {
                setFormData(res.data);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    fetchData();
  }, []);
  (0,react.useEffect)(function () {
    var fetchDataBlogs = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _pageData$parimaryCat2, endpoint, resp, _resp$data, results;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                setLoading(true);
                endpoint = "/public/blog-page/category/".concat(pageData === null || pageData === void 0 ? void 0 : (_pageData$parimaryCat2 = pageData.parimaryCategory) === null || _pageData$parimaryCat2 === void 0 ? void 0 : _pageData$parimaryCat2.slug, "?limit=10");
                _context2.next = 5;
                return api/* default.get */.Z.get(endpoint);

              case 5:
                resp = _context2.sent;
                setLoading(false);
                _resp$data = resp === null || resp === void 0 ? void 0 : resp.data, results = _resp$data.results;
                setPosts(results);
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                setLoading(false);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 11]]);
      }));

      return function fetchDataBlogs() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetchDataBlogs();
  }, []);
  var style = (posts === null || posts === void 0 ? void 0 : posts.length) === 0 ? {
    marginTop: "0"
  } : {}; // addvertisement functionality

  var ShowAddvertisement = function ShowAddvertisement() {
    var _pageData$categories, _pageData$categories2, _pageData$categories3, _pageData$categories4, _pageData$categories5, _pageData$categories6, _pageData$categories7, _pageData$categories8;

    if (catPrimary === "Study in UK" || pageData !== null && pageData !== void 0 && (_pageData$categories = pageData.categories) !== null && _pageData$categories !== void 0 && _pageData$categories.find(function (item) {
      return item.title === "Study in UK";
    }) || pageData !== null && pageData !== void 0 && (_pageData$categories2 = pageData.categories) !== null && _pageData$categories2 !== void 0 && _pageData$categories2.find(function (item) {
      return item.title === "Study in the UK";
    })) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(advertisement/* default */.Z, {
        width: 300,
        height: 250,
        src: "/ad/study-in-uk-mobile.webp",
        url: "https://myunisearch.com/lead/study-in-the-uk"
      });
    } else if (catPrimary === "Study in USA" || pageData !== null && pageData !== void 0 && (_pageData$categories3 = pageData.categories) !== null && _pageData$categories3 !== void 0 && _pageData$categories3.find(function (item) {
      return item.title === "Study in USA";
    }) || pageData !== null && pageData !== void 0 && (_pageData$categories4 = pageData.categories) !== null && _pageData$categories4 !== void 0 && _pageData$categories4.find(function (item) {
      return item.title === "Study in the USA";
    })) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(advertisement/* default */.Z, {
        width: 300,
        height: 250,
        src: "/ad/study-in-usa-mobile.webp",
        url: "https://myunisearch.com/lead/apply-for-scholarships-at-the-university-of-arizona"
      });
    } else if (catPrimary === "Study in Australia" || pageData !== null && pageData !== void 0 && (_pageData$categories5 = pageData.categories) !== null && _pageData$categories5 !== void 0 && _pageData$categories5.find(function (item) {
      return item.title === "Study in Australia";
    })) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(advertisement/* default */.Z, {
        width: 300,
        height: 250,
        src: "/ad/study-in-au-mobile.webp",
        url: "https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
      });
    } else if (catPrimary === "Study in Canada" || pageData !== null && pageData !== void 0 && (_pageData$categories6 = pageData.categories) !== null && _pageData$categories6 !== void 0 && _pageData$categories6.find(function (item) {
      return item.title === "Study in Canada";
    })) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(advertisement/* default */.Z, {
        width: 300,
        height: 250,
        src: "/ad/study-in-canada-mobile.webp",
        url: "https://myunisearch.com/lead/study-in-canada"
      });
    } else if (catPrimary === "Study in Ireland" || pageData !== null && pageData !== void 0 && (_pageData$categories7 = pageData.categories) !== null && _pageData$categories7 !== void 0 && _pageData$categories7.find(function (item) {
      return item.title === "Study in Ireland";
    })) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(advertisement/* default */.Z, {
        width: 300,
        height: 250,
        src: "/ad/study-in-ireland-mobile.webp",
        url: "#"
      });
    } else if (catPrimary === "study in New Zealand" || pageData !== null && pageData !== void 0 && (_pageData$categories8 = pageData.categories) !== null && _pageData$categories8 !== void 0 && _pageData$categories8.find(function (item) {
      return item.title === "Study in New Zealand";
    })) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(advertisement/* default */.Z, {
        width: 300,
        height: 250,
        src: "/ad/study-in-new-zealand-mobile.webp",
        url: "#"
      });
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(advertisement/* default */.Z, {
        width: 300,
        height: 250,
        src: "/ad/study-in-au-mobile.webp",
        url: "https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
      });
    }
  };

  var LeadFormComponent = function LeadFormComponent(_ref4) {
    var className = _ref4.className;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: formData && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((blog_single_body_module_default()).lead_form_wrapper, " ").concat(className !== null && className !== void 0 && className.root ? className === null || className === void 0 ? void 0 : className.root : ""),
        style: style,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (blog_single_body_module_default()).lead_form_heading_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
            className: "".concat((blog_single_body_module_default()).lead_heading, " ").concat(className !== null && className !== void 0 && className.heading ? className === null || className === void 0 ? void 0 : className.heading : ""),
            children: ["Want to study abroad? Sign up with", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "color-orange",
              children: "UniSearch!"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "".concat((blog_single_body_module_default()).lead_sub_heading, " ").concat(className !== null && className !== void 0 && className.subheading ? className === null || className === void 0 ? void 0 : className.subheading : ""),
            children: "Jumpstart your study abroad dreams with UniSearch"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LeadForm */.pn, {
          showTitle: false,
          showSubTitle: false,
          pageData: formData,
          buttonTitle: "Submit",
          pageSlug: formData === null || formData === void 0 ? void 0 : formData.slug,
          columnSizeFull: true
        })]
      })
    });
  };

  var contentFirst;
  var contentLast;
  var isShortCodeFormExist = pageData && (pageData === null || pageData === void 0 ? void 0 : pageData.content) && (pageData === null || pageData === void 0 ? void 0 : (_pageData$content = pageData.content) === null || _pageData$content === void 0 ? void 0 : _pageData$content.includes("[shortcode_form]"));

  if (isShortCodeFormExist) {
    var text = pageData === null || pageData === void 0 ? void 0 : pageData.content.split("[shortcode_form]");
    contentFirst = text[0];
    contentLast = text[1];
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (blog_single_body_module_default()).section_blog_body,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (blog_single_body_module_default()).wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (blog_single_body_module_default()).blog_body,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(social_sharing_links["default"], {
            className: (blog_single_body_module_default()).blog_links_wrapper,
            url: "".concat(baseUrl, "/blog/").concat(pageData === null || pageData === void 0 ? void 0 : pageData.slug),
            title: pageData === null || pageData === void 0 ? void 0 : pageData.title
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (blog_single_body_module_default()).body,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex justify-center mb-5 w-full",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                async: true,
                src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
                crossorigin: "anonymous"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ins", {
                className: "adsbygoogle",
                style: {
                  display: "inline-block",
                  width: "336px",
                  height: "280px"
                },
                "data-ad-client": "ca-pub-1690314786863972",
                "data-ad-slot": "7944985031"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                children: "(adsbygoogle = window.adsbygoogle || []).push({});"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "from_texteditor_wrapper",
              children: isShortCodeFormExist ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [(0,helpers/* addGoogleAdScript */.MG)(contentFirst, "<script async src=\"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972\"\n                            crossorigin=\"anonymous\"></script>\n                            <ins class=\"adsbygoogle\"\n                                style=\"display:inline-block;width:300px;height:250px\"\n                                data-ad-client=\"ca-pub-1690314786863972\"\n                                data-ad-slot=\"3075801734\"></ins>\n                            <script>\n                                (adsbygoogle = window.adsbygoogle || []).push({});\n                            </script>\n                         ", 40), /*#__PURE__*/(0,jsx_runtime.jsx)(LeadFormComponent, {
                    className: {
                      root: "!static !mb-8",
                      heading: "text-center !text-3xl max-w-[90%] mx-auto",
                      subheading: "text-center !text-base"
                    }
                  }), (0,helpers/* htmlParse */.QA)(contentLast)]
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: (0,helpers/* addGoogleAdScript */.MG)(pageData === null || pageData === void 0 ? void 0 : pageData.content, "<script async src=\"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972\"\n                        crossorigin=\"anonymous\"></script>\n                        <ins class=\"adsbygoogle\"\n                            style=\"display:inline-block;width:300px;height:250px\"\n                            data-ad-client=\"ca-pub-1690314786863972\"\n                            data-ad-slot=\"3075801734\"></ins>\n                        <script>\n                            (adsbygoogle = window.adsbygoogle || []).push({});\n                        </script>\n                    ", 90)
              })
            }), pageData && (pageData === null || pageData === void 0 ? void 0 : (_pageData$tags = pageData.tags) === null || _pageData$tags === void 0 ? void 0 : _pageData$tags.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (blog_single_body_module_default()).tags_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                children: pageData === null || pageData === void 0 ? void 0 : (_pageData$tags2 = pageData.tags) === null || _pageData$tags2 === void 0 ? void 0 : _pageData$tags2.map(function (tag, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      legacyBehavior: true,
                      href: "/blog/tag/".concat(tag === null || tag === void 0 ? void 0 : tag.slug),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: tag === null || tag === void 0 ? void 0 : tag.title
                      })
                    })
                  }, "blogtag".concat(i));
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-6 w-full flex justify-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                async: true,
                src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
                crossorigin: "anonymous"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ins", {
                className: "adsbygoogle",
                style: {
                  display: "block"
                },
                "data-ad-format": "autorelaxed",
                "data-ad-client": "ca-pub-1690314786863972",
                "data-ad-slot": "5945244324"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                children: "(adsbygoogle = window.adsbygoogle || []).push({});"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(UniComment, {
              commentType: "blog",
              referenceId: pageData === null || pageData === void 0 ? void 0 : pageData.id
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (blog_single_body_module_default()).sidebar,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShowAddvertisement, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: new Array(5).fill(1).map(function (_, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                      variant: "rectangular",
                      width: "100%",
                      height: 150
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                      variant: "rectangular",
                      width: "100%",
                      height: 20,
                      sx: {
                        margin: "15px 0px 0px 0px"
                      }
                    })]
                  }, i);
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (blog_single_body_module_default()).blog_grid_wrapper,
                children: (posts === null || posts === void 0 ? void 0 : posts.length) > 0 && (posts === null || posts === void 0 ? void 0 : posts.filter(function (post, i) {
                  return (pageData === null || pageData === void 0 ? void 0 : pageData.id) !== (post === null || post === void 0 ? void 0 : post.id);
                }).map(function (post, i) {
                  var _post$category, _post$category2, _post$posterImage, _post$featureImage;

                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(blog_grid_box/* default */.Z, {
                      blogTitle: post === null || post === void 0 ? void 0 : post.title,
                      blogLink: "/blog/".concat(post === null || post === void 0 ? void 0 : post.slug),
                      categoryTitle: post === null || post === void 0 ? void 0 : (_post$category = post.category) === null || _post$category === void 0 ? void 0 : _post$category.categoryName,
                      calegoryLink: "/blog/category/".concat(post === null || post === void 0 ? void 0 : (_post$category2 = post.category) === null || _post$category2 === void 0 ? void 0 : _post$category2.slug),
                      featureImage: (post === null || post === void 0 ? void 0 : (_post$posterImage = post.posterImage) === null || _post$posterImage === void 0 ? void 0 : _post$posterImage.src) || (post === null || post === void 0 ? void 0 : (_post$featureImage = post.featureImage) === null || _post$featureImage === void 0 ? void 0 : _post$featureImage.src),
                      videoType: post === null || post === void 0 ? void 0 : post.videoType
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                      children: i == 4 && /*#__PURE__*/(0,jsx_runtime.jsx)(ShowAddvertisement, {})
                    })]
                  }, i);
                }))
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(LeadFormComponent, {})]
          })]
        })
      })
    })
  });
};
/* harmony default export */ var blog_single_body = ((/* unused pure expression or super */ null && (BlogSingleBody)));
;// CONCATENATED MODULE: ./_modules/study/blog/blog_single/index.js




/***/ }),

/***/ 27890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _modules_study_common_play_btn_with_ripple__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42422);
/* harmony import */ var _blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96615);
/* harmony import */ var _blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);










var BlogBoxGrid = function BlogBoxGrid(_ref) {
  var spanTwoWithOverlay = _ref.spanTwoWithOverlay,
      colorWhite = _ref.colorWhite,
      blogTitle = _ref.blogTitle,
      blogLink = _ref.blogLink,
      categories = _ref.categories,
      featureImage = _ref.featureImage,
      videoType = _ref.videoType,
      summary = _ref.summary;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().box_grid), " ").concat(spanTwoWithOverlay ? "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().span_two_with_overlay)) : "", " "),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image_wrapper), " relative"),
      children: [videoType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        legacyBehavior: true,
        href: blogLink,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_common_play_btn_with_ripple__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            medium: !spanTwoWithOverlay,
            ripple: false
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: blogLink || "#",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
          blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
          placeholder: "blur",
          src: featureImage || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
          alt: blogTitle,
          width: 800,
          height: 500
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: (_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_info),
      children: [categories && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().category),
        children: categories === null || categories === void 0 ? void 0 : categories.map(function (cat, i, row) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            legacyBehavior: true,
            href: "/blog/category/".concat(cat === null || cat === void 0 ? void 0 : cat.slug),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("a", {
              className: (_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_cat_title),
              children: [cat === null || cat === void 0 ? void 0 : cat.title, row.length === ++i ? null : ", "]
            })
          }, "cat".concat(i));
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        legacyBehavior: true,
        href: blogLink || "#",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          style: {
            display: "block"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
            className: "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_title), " ").concat(colorWhite ? "".concat((_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().color_white)) : "", " "),
            children: blogTitle
          })
        })
      }), summary && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: spanTwoWithOverlay && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (_blog_box_grid_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blog_description),
          children: summary
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BlogBoxGrid);

/***/ }),

/***/ 47180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2804);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89093);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5434);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _unisearch_common_ui_element_actions_bookmark__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1692);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72145);
/* harmony import */ var _page_info_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3095);
/* harmony import */ var _page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);

var _excluded = ["data", "pageType", "id", "authorName", "authorImage"];

/* eslint-disable @next/next/no-img-element */












var PageInfo = function PageInfo(_ref) {
  var _data$publishDate, _data$totalView, _data$comments;

  var data = _ref.data,
      pageType = _ref.pageType,
      id = _ref.id,
      authorName = _ref.authorName,
      authorImage = _ref.authorImage,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_2__/* .authAtom */ .L4);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().short_info),
    children: [data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().author), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
          src: authorImage || "/favicon.jpg",
          alt: authorName || "author",
          width: 30,
          height: 30
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: authorName
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Author"
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.publishDate) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().date), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdCalendarToday */ .kVv, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: moment__WEBPACK_IMPORTED_MODULE_3___default()((_data$publishDate = data.publishDate) !== null && _data$publishDate !== void 0 ? _data$publishDate : new Date()).format("MMM DD, YYYY")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Date Published "
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.totalView) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().view), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdRemoveRedEye */ .FpO, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: (_data$totalView = data.totalView) !== null && _data$totalView !== void 0 ? _data$totalView : ""
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Views"
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.comments) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().comment), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdForum */ .Rlc, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) || 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Comments"
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_unisearch_common_ui_element_actions_bookmark__WEBPACK_IMPORTED_MODULE_5__["default"], {
      referance: pageType,
      referanceId: id ? parseInt(id) : "",
      is_bookmarked: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .isReadingListed */ .uO)(profileInfo, pageType, id)
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageInfo);

/***/ }),

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PlayButtonWithRipple; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30890);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["colorOrange", "medium", "ripple", "small"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PlayButtonWithRipple = function PlayButtonWithRipple(_ref) {
  var colorOrange = _ref.colorOrange,
      medium = _ref.medium,
      _ref$ripple = _ref.ripple,
      ripple = _ref$ripple === void 0 ? true : _ref$ripple,
      small = _ref.small,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", _objectSpread(_objectSpread({
    className: "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play_btn), " ").concat(colorOrange ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().orange)) : "", " ").concat(medium ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().medium)) : "", " ").concat(small ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small)) : "")
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow_right)
    }), ripple && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ripple_effect)
    })]
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButtonWithRipple);

/***/ }),

/***/ 83380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SocialSharingLinks": function() { return /* binding */ SocialSharingLinks; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21818);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89583);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86893);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76300);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);

var _excluded = ["url", "title", "hashtag"];






var SocialSharingLinks = function SocialSharingLinks(_ref) {
  var url = _ref.url,
      title = _ref.title,
      hashtag = _ref.hashtag,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "".concat((_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default().social_links_wrapper), " ").concat(props.className),
    style: props.style,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .FacebookShareButton */ .Dk, {
      url: url,
      quote: title,
      hashtag: hashtag,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiFacebook */ .Bsb, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .TwitterShareButton */ .B, {
      url: url,
      title: title,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiTwitter */ .Ccr, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .LinkedinShareButton */ .r2, {
      url: url,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiLinkedin */ .qOw, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .WhatsappShareButton */ .N0, {
      url: url,
      title: title,
      separator: ":: ",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaWhatsapp */ .xpo, {})
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (SocialSharingLinks);

/***/ }),

/***/ 72275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86893);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Advertisement = function Advertisement(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? "#" : _ref$url,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? "/temp/add-row.png" : _ref$src,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "900" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "110" : _ref$height,
      className = _ref.className,
      style = _ref.style,
      _ref$isPlaceholder = _ref.isPlaceholder,
      isPlaceholder = _ref$isPlaceholder === void 0 ? false : _ref$isPlaceholder;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      show = _useState[0],
      setShow = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: show && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      style: {
        style: style
      },
      className: "flex justify-center ".concat(className ? className : ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "relative",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
          onClick: function onClick() {
            return setShow(false);
          },
          className: "absolute right-[1px] top-[1px] bg-white z-10 hover:text-red-600 transition-all",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_3__/* .FiX */ .q5L, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
          href: url,
          rel: "nofollow",
          target: "_blank",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
            alt: "Advertisement",
            src: src,
            width: width,
            height: height,
            style: {
              height: height
            }
          })
        }), isPlaceholder && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "absolute text-white text-[50px] font-semibold z-10 w-full text-center",
          style: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          },
          children: [width, " x ", height]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Advertisement);

/***/ }),

/***/ 56753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var GoogleAdTop = function GoogleAdTop(_ref) {
  var className = _ref.className;

  var _useWindowDimensions = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
      width = _useWindowDimensions.width;

  var showGoogleAdScriptTop = function showGoogleAdScriptTop() {
    if (width > 0 && width < 640) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "450px",
            height: "250px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "8403655196"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    } else if (width > 640 && width < 1024) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "720px",
            height: "90px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "2900310407"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    } else if (width > 1024) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "1000px",
            height: "250px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "9661445287"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "flex justify-center mx-auto mb-5 ".concat(className ? className : ""),
    children: showGoogleAdScriptTop()
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GoogleAdTop);

/***/ }),

/***/ 1692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BookmarkAction": function() { return /* binding */ BookmarkAction; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8612);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89093);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89583);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2804);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_icons_im__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53990);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);















var BookmarkAction = function BookmarkAction(_ref) {
  var customClasses = _ref.customClasses,
      referance = _ref.referance,
      referanceId = _ref.referanceId,
      is_bookmarked = _ref.is_bookmarked,
      _ref$showText = _ref.showText,
      showText = _ref$showText === void 0 ? true : _ref$showText,
      _ref$getReadingList = _ref.getReadingList,
      getReadingList = _ref$getReadingList === void 0 ? false : _ref$getReadingList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useSystemActions */ .x3)();
  var authActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useAuthActions */ .X$)();
  var profileInfos = (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_5__/* .authAtom */ .L4); //referanceItems =  (blog,page )

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    //remove redirect url
    systemActions.removeReturnUrl();
  }, [systemActions]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (profileInfos) {
      setProfileInfo(profileInfos);
    }
  }, []); //Handle Bookmarke

  var handleBookmark = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(profileInfo && profileInfo.userTypeSlug === "student")) {
                _context2.next = 7;
                break;
              }

              setIsLoading(true);
              payload = {
                readingType: referance,
                referenceId: referanceId
              };
              _context2.next = 5;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/student/reading-list", payload).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resp) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(!resp.error && resp.data)) {
                            _context.next = 7;
                            break;
                          }

                          _context.next = 3;
                          return authActions.getProfile();

                        case 3:
                          setIsLoading(false);
                          if (getReadingList) getReadingList();
                          _context.next = 9;
                          break;

                        case 7:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .swalError */ .Kj)(resp.error);
                          setIsLoading(false);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 5:
              _context2.next = 10;
              break;

            case 7:
              systemActions.setReturnUrl(router.asPath);
              _context2.next = 10;
              return router.push({
                pathname: "/signin"
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleBookmark() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: is_bookmarked ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bookmarke_wrapper), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("button", {
        className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn_bookmark), " ").concat(is_bookmarked ? (_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active) : "", " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.btnClass ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.btnClass : ""),
        onClick: function onClick() {
          return handleBookmark();
        },
        children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaBookmark */ .VF9, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().reg_bookmark)),
          style: {
            color: "#f47f20"
          }
        }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_12__/* .ImSpinner8 */ .IDg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon_spin))
        }), showText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          children: "Bookmarked"
        })]
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "relative ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bookmarke_wrapper), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("button", {
        className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn_bookmark), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.btnClass ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.btnClass : ""),
        onClick: function onClick() {
          return handleBookmark();
        },
        children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaRegBookmark */ .mCg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().reg_bookmark))
        }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_12__/* .ImSpinner8 */ .IDg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon_spin))
        }), showText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          children: "Add to Bookmark"
        })]
      }), (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isEmpty */ .xb)(profileInfo) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: "uni-tooltip",
        children: ["Please Login ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " to perform this action"]
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (BookmarkAction);

/***/ }),

/***/ 28257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blog_single_body_wrapper__zaU1w","blog_body":"blog_single_body_blog_body__R6_n_","blog_grid_wrapper":"blog_single_body_blog_grid_wrapper__zm7_g","blog_links_wrapper":"blog_single_body_blog_links_wrapper__ocf3r","tags_wrapper":"blog_single_body_tags_wrapper__XUrqv","sidebar":"blog_single_body_sidebar__fsjih","lead_form_wrapper":"blog_single_body_lead_form_wrapper__UKk0G","lead_form_heading_wrapper":"blog_single_body_lead_form_heading_wrapper__jSs_2","lead_heading":"blog_single_body_lead_heading__f3paS","lead_sub_heading":"blog_single_body_lead_sub_heading__u1LJK"};

/***/ }),

/***/ 60740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"blog_single_hero___next__J71IM","section_study_banner":"blog_single_hero_section_study_banner__qZ69l","hero_container":"blog_single_hero_hero_container__M3Oy5","summary":"blog_single_hero_summary__daQLy","sub_heading":"blog_single_hero_sub_heading__xhv6v","breadcrumbs":"blog_single_hero_breadcrumbs___nKxl","active":"blog_single_hero_active__iK7Ah","short_info":"blog_single_hero_short_info__FXpww","info_item":"blog_single_hero_info_item__XtDzL","author":"blog_single_hero_author__XsJ2N","text":"blog_single_hero_text__ub1Go","desc":"blog_single_hero_desc__3kivF","info_button":"blog_single_hero_info_button__PTYeh"};

/***/ }),

/***/ 96615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"blog_box_grid___next__4_7eN","box_grid":"blog_box_grid_box_grid__YVetP","blog_title":"blog_box_grid_blog_title__MH6gN","image_wrapper":"blog_box_grid_image_wrapper__4yWy3","video_popup":"blog_box_grid_video_popup__33tnX","blog_info":"blog_box_grid_blog_info__sxxqz","category":"blog_box_grid_category__vG7qN","blog_cat_title":"blog_box_grid_blog_cat_title__yunve","color_white":"blog_box_grid_color_white__Hg9BK","span_two_with_overlay":"blog_box_grid_span_two_with_overlay__AbnHS","blog_description":"blog_box_grid_blog_description__o5Ei8"};

/***/ }),

/***/ 3095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"page_info___next__KpAYC","short_info":"page_info_short_info__2CVJV","info_item":"page_info_info_item__PvuOa","icon":"page_info_icon__TsLci","author":"page_info_author__pq2Y3","text":"page_info_text__cqeYo","name":"page_info_name__tcb28","desc":"page_info_desc__aF06O"};

/***/ }),

/***/ 30890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"play_btn_with_ripple_play_btn__yNA0_","arrow_right":"play_btn_with_ripple_arrow_right__Fmzao","ripple_effect":"play_btn_with_ripple_ripple_effect__4Jxcn","ModalRipple":"play_btn_with_ripple_ModalRipple__5yAi9","medium":"play_btn_with_ripple_medium__ClXl0","small":"play_btn_with_ripple_small__EszEQ","orange":"play_btn_with_ripple_orange__1q96e"};

/***/ }),

/***/ 76300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social_links_wrapper":"social_links_social_links_wrapper__k2gOD"};

/***/ }),

/***/ 53913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"favourite_wrapper":"actions_favourite_wrapper__mmZgl","icon_heart":"actions_icon_heart__MtTT3","selected":"actions_selected__bf0TV","icon_swap":"actions_icon_swap__irRwk","compare_wrapper":"actions_compare_wrapper__z_sdX","bookmarke_wrapper":"actions_bookmarke_wrapper__31rzO","btn_bookmark":"actions_btn_bookmark__pq8QI","active":"actions_active__vtMRT","icon_spin":"actions_icon_spin__z5nco","spin":"actions_spin__kUes6","connect_wrapper":"actions_connect_wrapper__ESCJU","reply_box_wrapper":"actions_reply_box_wrapper__AVnAn","reply_box_to":"actions_reply_box_to__rmbnD","reply_box_subject":"actions_reply_box_subject__CBp2A","reply_box_actions":"actions_reply_box_actions__GBlrl","reply_box_action_right":"actions_reply_box_action_right__4oLns"};

/***/ })

}]);